<script>
import Quizz2DStep from '@/components/activity/Quizz2DStep'
import QuizzSuccessIcon from '@/assets/imgs/quiz-success.svg'
import QuizzFailIcon from '@/assets/imgs/quiz-fail.png'
import { useGtag } from "vue-gtag-next";

export default {
  name: 'ContentActivity',
  components: {
    Quizz2DStep,
    QuizzSuccessIcon
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    files: {
      type: Object,
      required: true
    },
    activity: {
      type: String,
      required: true
    }
  },
  emits: ['score', 'close'],
  data() {
    return {
      step: 0,
      start: null,
      scores: 0,
      finished: false,
      finishSuccess: false
    }
  },
  computed: {
    steps() {
      return this.content.questions.length
    },
    limited() {
      return this.content.scores.repeats > 0
    },
    possibleGames() {
      if (!this.limited)
        return 0
      const scores = this.$store.getters['user/score/list'].filter(score => score.activity === this.activity).length
      return this.content.scores.repeats - scores
    },
    canPlay() {
      return this.steps > 0 && this.limited
        ? this.possibleGames > 0
        : true
    }
  },
  methods: {
    startQuiz() {
      const now = new Date()
      this.start = now
      this.step = 1

      const { event } = useGtag();
      const track = () => {
        event("quiz_start", {
          event_category: "quiz_start",
          quizId: this.activity,
          userUid: this.$store.state.user.data.uid,
          userRole: this.$store.state.user.data.role,
          userEmail: this.$store.state.user.data.email,
          userDisplayName: this.$store.state.user.data.displayName,
        });
      };
      track();



    },
    async closeStep(score) {
      this.scores += score
      if (this.steps > this.step) {
        this.step++
      } else {
        this.finishSuccess = this.scores >= this.content.scores.success
        this.finished = true
        const now = new Date()
        const dbscore = {
          activity: this.activity,
          gameStart: this.start,
          displayName: this.$store.state.user.data.displayName,
          gameEnd: now,
          runtime: now.getTime() - this.start.getTime(),
          score: this.scores
        }
        this.$emit('score', this.scores)
        await this.$store.dispatch('user/submitActivityScore', dbscore)


        const { event } = useGtag();
        const track = () => {
          event("quiz_end", {
            event_category: "quiz_end",
            quizId: this.activity,
            score: this.scores,
            userUid: this.$store.state.user.data.uid,
            userRole: this.$store.state.user.data.role,
            userEmail: this.$store.state.user.data.email,
            userDisplayName: this.$store.state.user.data.displayName,
          });
        };
        track();
      }
    }
  },
  created() {
    this.$store.commit('ui/setLeaderboard', this.activity)
  },
  beforeUnmount() {
    this.$store.commit('ui/setLeaderboard', 'global')
  },
  setup() {
    return { QuizzFailIcon }
  }
}
</script>

<template>
<div class="h-full quiz-wrapper font-size-18">
  <div class="quiz-wrapper-container d-flex justify-center align-items-center text-center">
    <div v-if="step === 0">
      <div v-if="!canPlay">
        <div v-if="steps > 0">
          <div v-if="limited" class="font-size-14 pa-5" :innerHTML="$t('activity.quiz.maxGamesReached')"/>
        </div>
        <div v-else>
          <div v-if="limited" class="font-size-14 pa-5" :innerHTML="$t('activity.quiz.underConstruction')"/>

        </div>
      </div>
      <div v-else>
        <div class="quiz-intro font-size-24 px-10" :innerHTML="$l(content.intro)"/>
        <div v-if="limited" class="font-size-14 px-5 mb-10 mt-2 text-fb-grey" :innerHTML="possibleGames === 1 ? $t('activity.quiz.maxGamesOne') : $t('activity.quiz.maxGamesMore', {max: possibleGames})"/>
        <div class="mb-10">
          <svg width="153" height="162" viewBox="0 0 153 162" fill="none" ><path d="M79.918 42.252c0 1.06.94 1.926 2.001 1.926a1.925 1.925 0 100-3.852h-.158c-1.06 0-1.843.858-1.843 1.926zM57.906 88.463c.361.3.798.444 1.226.444.55 0 1.106-.233 1.482-.7a1.922 1.922 0 00-.255-2.708C49.075 76.142 49.18 63.24 49.18 63.07v-13.48a1.93 1.93 0 00-1.925-1.926 1.93 1.93 0 00-1.926 1.926v13.435c-.008.601-.188 14.856 12.577 25.44v-.001zM47.264 125.171c-1.061 0-1.926.857-1.926 1.926v9.628a1.925 1.925 0 103.851 0v-9.628a1.924 1.924 0 00-1.925-1.926z" fill="currentColor"/><path d="M150.446 145.872h-22.627v-3.046a1.92 1.92 0 00-1.925-1.926h-6.101l.008-20.018a1.92 1.92 0 00-1.926-1.925H107.84v-8.704a1.919 1.919 0 00-1.925-1.925H92.976v-7.598a41.21 41.21 0 0019.55-15.202c.015 0 .03.007.045.007.12 0 .241-.015.361-.037 27.501-5.251 24.936-31.21 24.915-31.474a1.928 1.928 0 00-1.911-1.715h-16.135l-.008-10.058c0-1.06-.857-1.925-1.925-1.925H87.38a1.925 1.925 0 00-1.926 1.925c0 1.061.858 1.926 1.926 1.926h28.57v18.076c0 20.528-16.7 37.228-37.228 37.228-20.528 0-37.228-16.7-37.228-37.228l-.007-18.076h34.18a1.93 1.93 0 001.927-1.926 1.93 1.93 0 00-1.926-1.925H39.56a1.93 1.93 0 00-1.926 1.925v10.065H21.267a1.929 1.929 0 00-1.926 1.813c-.015.256-1.166 25.614 25.41 31.195a41.235 41.235 0 0020.745 15.781v7.214H52.468c-1.06 0-1.926.858-1.926 1.926v8.703h-10.99c-1.06 0-1.926.858-1.926 1.926v20.018h-6.1c-1.06 0-1.926.857-1.926 1.925v3.047l-27.674.007a1.925 1.925 0 100 3.852h27.682v3.054c0 1.068.865 1.925 1.925 1.925h94.36a1.92 1.92 0 001.926-1.925v-3.054h22.627a1.92 1.92 0 001.925-1.926 1.92 1.92 0 00-1.925-1.926v.001zm-30.645-83.626v-6.085h14.307c.038 5.115-1.406 20.002-18.881 24.838 2.896-5.62 4.574-11.991 4.574-18.753zM23.2 56.17h14.435v6.085c0 6.612 1.61 12.84 4.393 18.385C25.637 75.463 23.44 61.262 23.2 56.169zm46.157 46.043c3.009.707 6.138 1.121 9.365 1.121 3.603 0 7.079-.511 10.41-1.392v6.387H69.357v-6.116zm-14.954 9.967h49.587v6.778H54.403v-6.778zm-12.916 10.629h74.463v18.091H41.487v-18.091zm82.482 28.042H33.461v-6.1h90.508v6.1zM99.656 158.149H53.2a1.925 1.925 0 100 3.851h46.457a1.92 1.92 0 001.926-1.926 1.92 1.92 0 00-1.926-1.925zM110.729 158.149h-6.499a1.92 1.92 0 00-1.926 1.925A1.92 1.92 0 00104.23 162h6.499a1.92 1.92 0 001.926-1.926 1.92 1.92 0 00-1.926-1.925zM78.714 35.144a1.925 1.925 0 001.926-1.926V13.721a1.925 1.925 0 10-3.851 0v19.497a1.93 1.93 0 001.925 1.926zM78.714 9.147a1.925 1.925 0 001.926-1.926V1.926a1.925 1.925 0 10-3.851 0V7.22a1.93 1.93 0 001.925 1.926zM55.05 14.805l7.77 17.88a1.92 1.92 0 001.768 1.159 1.926 1.926 0 001.768-2.693l-7.771-17.88a1.926 1.926 0 10-3.536 1.534zM52.46 8.847a1.92 1.92 0 001.768 1.158 1.927 1.927 0 001.768-2.693l-2.114-4.86a1.926 1.926 0 10-3.535 1.535l2.114 4.86zM50.084 37.054a1.921 1.921 0 002.716-.188 1.92 1.92 0 00-.188-2.715L37.913 21.34a1.92 1.92 0 00-2.716.187 1.92 1.92 0 00.188 2.716l14.699 12.81zM30.488 19.971a1.922 1.922 0 002.716-.188 1.92 1.92 0 00-.188-2.715l-3.987-3.476a1.921 1.921 0 00-2.715.189 1.92 1.92 0 00.188 2.715l3.986 3.476zM109.818 37.528c.451 0 .903-.158 1.264-.474l14.698-12.81c.798-.7.888-1.918.188-2.716a1.92 1.92 0 00-2.715-.188l-14.699 12.81a1.929 1.929 0 00-.188 2.716c.384.437.918.662 1.452.662zM129.414 20.445c.451 0 .902-.158 1.264-.474l3.994-3.483c.797-.7.887-1.918.188-2.715a1.921 1.921 0 00-2.716-.188l-3.994 3.483a1.928 1.928 0 001.264 3.377zM92.548 33.684a1.932 1.932 0 002.535-1l7.771-17.88a1.92 1.92 0 00-1.001-2.536 1.918 1.918 0 00-2.535 1l-7.77 17.881a1.92 1.92 0 001 2.535zM102.905 9.846a1.932 1.932 0 002.535-1l2.114-4.86a1.92 1.92 0 00-1.001-2.535 1.918 1.918 0 00-2.535 1l-2.113 4.86a1.925 1.925 0 001 2.535z" fill="currentColor"/></svg>
        </div>
        <v-btn
          rounded="pill"
          color="primary"
          @click="startQuiz"
        >{{$t('buttons.start')}}</v-btn>
      </div>
    </div>
    <div v-if="step > 0 && !finished">
      <div
        class="font-size-14 text-admin-grey-4"
      >
        {{$t('activity.quiz.questionX',{num: step})}}
      </div>
      <Quizz2DStep
        :question="content.questions[step-1]"
        :files="files"
        :stepi="step"
        :quizid="activity"
        @closeStep="closeStep"
      />
    </div>
    <div
      v-if="finished"
    >
      <QuizzSuccessIcon v-if="scores > 0"/>
      <img class="quiz-fail-icon" v-else :src="QuizzFailIcon" alt="quize less score" />
      <div class="mt-10 mb-6">
        <h4 class="text-admin-grey-4" v-html="$t('activity.quiz.resultScore')"/>
        <h2 class="font-size-40">{{ scores }}</h2>
      </div>
      <p class="font-size-14 text-admin-grey-4" v-if="finishSuccess" :innerHTML="$l(content.scores.successMessage)"/>
      <p class="font-size-14 text-admin-grey-4" v-else :innerHTML="$l(content.scores.failMessage)"/>
      <v-btn
        color="white"
        class="mt-10"
        @click="$emit('close')"
      >
        {{$t('buttons.finish')}}
      </v-btn>
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.quiz-wrapper {
  position: relative;

  &-container{
    min-height: 100%;
  }
}
.quiz-fail-icon{
  max-width:200px;
  display: block;
  margin:0 auto;
}
</style>
